<!-- Conversations section -->
<mat-card appearance="outlined" *ngIf="showInboxPreviewPane" class="mat-card--no-content-padding">
  <mat-card-header class="mat-card-header-with-action">
    <mat-card-title>
      {{ 'INBOX.PREVIEW_PANE.TITLE' | translate }}
    </mat-card-title>
    <a *ngIf="(showEmptyState$ | async) === false" mat-button color="primary" [routerLink]="inboxRoute()">
      {{ 'INBOX.PREVIEW_PANE.GO_TO_INBOX' | translate }}
    </a>
  </mat-card-header>
  <mat-card-content>
    <ng-container *ngIf="showEmptyState$ | async; else listConversations">
      <glxy-empty-state [size]="'small'">
        <glxy-empty-state-hero>
          <mat-icon>question_answer</mat-icon>
        </glxy-empty-state-hero>
        <p>{{ 'INBOX.PREVIEW_PANE.EMPTY_STATE.INFO' | translate }}</p>
        <glxy-empty-state-actions>
          <button mat-stroked-button color="primary" (click)="startNewMessage()">
            {{ 'INBOX.PREVIEW_PANE.EMPTY_STATE.SEND_MESSAGE' | translate }}
          </button>
        </glxy-empty-state-actions>
      </glxy-empty-state>
    </ng-container>
    <ng-template #listConversations>
      <div class="conversation-list" [ngClass]="{ 'empty-conversation-list': (showEmptyState$ | async) }">
        <div
          *ngFor="let conversationDetail of conversations$ | async; trackBy: trackConversationDetailsById"
          class="conversation"
        >
          <a
            *ngIf="conversationDetail"
            [routerLink]="conversationDetail | conversationRoute"
            routerLinkActive="active-conversation"
            data-action="clicked-conversation"
          >
            <div
              [ngClass]="{
                'unread-font-weight': (conversationDetail.conversation | conversationUnseen | async)
              }"
            >
              <div class="header-container row">
                <div *ngIf="displayBadge" class="badges-group">
                  <div *ngFor="let badge of conversationDetail | conversationBadge" class="badge">
                    <glxy-badge [color]="badge?.badgeColor" [size]="'small'">
                      {{ badge?.participantType | translate }}
                    </glxy-badge>
                  </div>
                </div>
                <div class="side-info-container row">
                  <div
                    class="timestamp"
                    [ngClass]="{
                      'unread-color': (conversationDetail?.conversation | conversationUnseen | async)
                    }"
                  >
                    {{ conversationDetail | timestamp }}
                  </div>
                  <div
                    class="dot-container"
                    [ngClass]="{
                      'unread-display': (conversationDetail?.conversation | conversationUnseen | async)
                    }"
                  >
                    <div class="dot"></div>
                  </div>
                </div>
              </div>
              <div>
                <inbox-conversation-title [conversationDetail]="conversationDetail"></inbox-conversation-title>
                <inbox-conversation-preview [conversationDetail]="conversationDetail"></inbox-conversation-preview>
              </div>
            </div>
          </a>
        </div>
      </div>
    </ng-template>
  </mat-card-content>
</mat-card>
